{"calendarName":"Abwesenheiten","eventTitle":"{name}: {type}{half, select, yes { (½ Tag)} other {}}"}